
import { SidebarProvider } from "@/components/ui/sidebar";
import { AdminSidebar } from "@/components/AdminSidebar";
import { CreateClientDialog } from "@/components/client/CreateClientDialog";
import { ClientTable } from "@/components/client/ClientTable";
import { DeleteConfirmationDialog } from "@/components/client/DeleteConfirmationDialog";
import { ImportClientsDialog } from "@/components/client/ImportClientsDialog";
import { useClients } from "@/hooks/useClients";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { APIInformation } from "@/components/api/APIInformation";
import { Button } from "@/components/ui/button";
import { FileCode } from "lucide-react";

const Client = () => {
  const {
    clients,
    loading,
    clientToDelete,
    setClientToDelete,
    handleDelete,
    fetchClients,
    searchQuery,
    handleSearchChange,
    page,
    pageSize,
    totalCount,
    handlePageChange
  } = useClients();
  
  return <SidebarProvider>
      <div className="flex min-h-screen w-full bg-gray-200">
        <AdminSidebar />
        <div className="flex-1">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            <div className="mb-6 flex justify-between items-start">
              <div>
                <h1 className="text-4xl font-bold" style={{
                color: "#008169"
              }}>
                  Schools
                </h1>
                <p className="text-xl text-gray-600 mt-2">
                  Manage schools and institutions
                </p>
              </div>
              <div className="flex gap-2">
                <ImportClientsDialog onImportComplete={fetchClients} />
                <CreateClientDialog onClientCreated={fetchClients} />
              </div>
            </div>

            <Tabs defaultValue="schools" className="w-full">
              <TabsList className="mb-6">
                <TabsTrigger value="schools">Schools</TabsTrigger>
                <TabsTrigger value="api">API</TabsTrigger>
              </TabsList>
              
              <TabsContent value="schools">
                <div className="bg-white rounded-lg shadow-sm p-6 px-[20px] py-[20px]">
                  <div>
                    <ClientTable 
                      clients={clients} 
                      loading={loading} 
                      onDelete={setClientToDelete} 
                      onClientUpdated={fetchClients} 
                      searchQuery={searchQuery} 
                      onSearchChange={handleSearchChange} 
                      page={page} 
                      pageSize={pageSize} 
                      totalCount={totalCount} 
                      onPageChange={handlePageChange} 
                    />
                  </div>
                </div>
              </TabsContent>
              
              <TabsContent value="api">
                <div className="mb-4 flex justify-end">
                  <Button 
                    variant="outline" 
                    onClick={() => window.location.href = "/admin/school-api-docs"}
                    className="flex items-center gap-2"
                  >
                    <FileCode className="h-4 w-4" />
                    View Full API Documentation
                  </Button>
                </div>
                <APIInformation />
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </div>

      <DeleteConfirmationDialog isOpen={!!clientToDelete} onClose={() => setClientToDelete(null)} onConfirm={() => clientToDelete && handleDelete(clientToDelete)} />
    </SidebarProvider>;
};

export default Client;
